module.exports = __webpack_public_path__ + "static/media/portfolio6-4.47cc10a2.png";